// Tiny module-level event bus so non-React modules (like Rest.js) can signal
// React components without holding a context reference.

const target = new EventTarget()

const LOGGED_OUT = 'app:logged-out'

export const emitLoggedOut = (message) =>
  target.dispatchEvent(new CustomEvent(LOGGED_OUT, { detail: { message } }))

export const onLoggedOut = (handler) => {
  const fn = (e) => handler(e.detail?.message)
  target.addEventListener(LOGGED_OUT, fn)
  return () => target.removeEventListener(LOGGED_OUT, fn)
}
